module.exports = __webpack_public_path__ + "img/Overview.2f059c74.jpg";